'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Scroll = void 0;
const $ = require("jquery");
class Scroll {
    constructor() {
        const self = this;
        $('a[href^="#"], a[href*="/#"]').click(function (e) {
            const href = $(this).attr("href");
            // 「同一ページ内#アンカーリンク」の条件
            const isSamePage = href.startsWith("#") ||
                href.split("#")[0] === location.origin + location.pathname ||
                href.split("#")[0] === location.pathname ||
                href.startsWith(location.pathname + "#");
            // 「別ページ#アンカーリンク」 の場合は、通常のリンク遷移させる（スムーススクロール無視）
            // トクセン工業を知るの技術情報ページで、「この製造工程を知る」ボタンの機能を使えるようにするため
            if (!isSamePage) {
                return;
            }
            // 「同一ページ内#アンカーリンク」だけが対象
            e.preventDefault();
            if (self.isAnchor(href)) {
                self.scrollToAnchor(href);
            }
        });
        // URLがアンカーリンク付きだった時
        // window.addEventListener('load', () => {
        $(window).on('load', () => {
            const url = location.href;
            if (this.isAnchor(url)) {
                $("html, body").animate({ scrollTop: 0 }, 0, 'linear');
                setTimeout(() => {
                    self.scrollToAnchor(url);
                }, 300);
                return false;
            }
        });
    }
    isAnchor(href) {
        return href.indexOf('#') != -1;
    }
    getAnchorName(href) {
        const index = href.indexOf('#');
        return href.slice(index + 1);
    }
    scrollToAnchor(href) {
        const anchor = this.getAnchorName(href);
        const $target = $('#' + anchor);
        // ターゲットが存在しない場合は処理を終了
        if ($target.length === 0) {
            return;
        }
        // 基本となるヘッダーの高さ
        let headerHeight = $('.paramHeader').outerHeight() | 0;
        // 「サステナビリティ」ページのみアンカーリンクの着地点を変更
        let sustainabilityNaviHeight = $('.paramSustainabilityNavi').outerHeight() | 0;
        let position; // スクロール位置を格納するための変数
        const targetTop = $target.offset().top; // アンカーのトップ位置を取得
        // 「サステナビリティ」ページかどうかを判断し、着地点を調整
        if (sustainabilityNaviHeight > 0) {
            // 「サステナビリティ」ページの場合：PC/TABサイズのみ、ナビゲーション分の高さも引く
            const mediaQuery = window.matchMedia('(min-width: 768px)');
            const checkWindow = (mq) => {
                if (mq.matches) {
                    position = targetTop - headerHeight - sustainabilityNaviHeight - 20; // PC の着地点
                }
                else {
                    position = targetTop - headerHeight - 20; // SP の着地点
                }
            };
            checkWindow(mediaQuery); // 初回判定
            mediaQuery.addEventListener('change', checkWindow); // 画面幅変更時
        }
        else {
            // 通常のページの場合: 基本ヘッダーの分だけを引く
            position = targetTop - headerHeight - 20;
        }
        $("html, body").animate({ scrollTop: position }, 400, 'linear');
    }
}
exports.Scroll = Scroll;
exports.default = Scroll;
